import clsx from 'clsx';
import type { ReactNode } from 'react';

import { DataTestIds } from '@repo/frontend-shared';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';

import { Scroller } from '../Scroller/Scroller';
import { SidebarItem } from '../SidebarItem/SidebarItem';

import './Sidebar.scss';

interface SidebarItemProps {
  icon: ReactNode;
  title: string;
  path: string;
  chip?: ReactNode;
  compressed?: boolean;
  disabled?: boolean;
  testid?: string;
}

interface SidebarProps {
  items: SidebarItemProps[];
  compressed?: boolean;
  dataTestId?: string;
}

export function Sidebar({ dataTestId, items, compressed = false }: SidebarProps) {
  const sidebarClassName = clsx('Sidebar', {
    'Sidebar--compressed': compressed,
  });

  return (
    <aside data-testid={dataTestId ?? DataTestIds.COMMON.SIDEBAR.CONTAINER} className={sidebarClassName}>
      <Scroller scrollBarVisableOnHover>
        <SDSFlexbox direction="column" gap="card-large" className="Sidebar__content">
          {items.map(item => (
            <SidebarItem testid={item.testid} key={item.title} {...item} compressed={compressed} />
          ))}
        </SDSFlexbox>
      </Scroller>
    </aside>
  );
}
